(function($) {
    'use strict';

    $('#suggest').find('form').on('submit', function(e) {
        e.preventDefault();
        var $this = $(this),
            fUrl = $this.attr('action'),
            fData = $this.serialize();

        $.ajax({
            url: fUrl,
            method: 'POST',
            data: fData
        }).done(function(){
            $('#suggestions-close').trigger('click');
        }).fail(function(){
            alert('email address is invalid');
        });

    });

}(jQuery));
